import { render, staticRenderFns } from "./SysConfig.vue?vue&type=template&id=2393f6dc&scoped=true&"
import script from "./SysConfig.vue?vue&type=script&lang=js&"
export * from "./SysConfig.vue?vue&type=script&lang=js&"
import style0 from "./SysConfig.vue?vue&type=style&index=0&id=2393f6dc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2393f6dc",
  null
  
)

export default component.exports